import React from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../../Theme'
import { Breadcrumbs } from '../../BreadCrumbs/BreadCrumbs'
import Collapsible from '../Collapsible'

const HeroContainer = styled.div`
   position: relative;
   background-color: ${theme.colors.white};

   .page-hero {
      position: relative;
      border-radius: 0 !important;
      overflow: hidden;
   }

   .page-hero-title {
      display: block;
      font-size: 2rem;
      color: ${props => (props.hasBackgroundImage ? '#fff' : '#000')};
      text-shadow: ${props =>
         props.hasBackgroundImage ? '0 0 2rem #000' : 'none'};
      ${theme.below.sm} {
         font-size: 1.6em;
      }
   }

   .page-hero-mobile-description {
      width: 100%;

      ${theme.below.xl} {
         padding-left: 4rem;
         padding-right: 4rem;
         padding-bottom: 1.5rem;
      }

      ${theme.below.md} {
         padding-right: 1.5rem;
         padding-left: 1.5rem;
         padding-bottom: 1rem;
      }
   }

   .page-hero-mobile-separator {
      background-color: ${props =>
         props.hasBackgroundImage ? 'white' : 'black'};
      opacity: 0.8;
      width: 100%;
      height: 1px;
   }


   .page-hero .img-background {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
   }

   article.collapsible-card-wrapper > div {
      max-width: 700px;
   }
`

const MobileOverlayBottom = styled.div`
   height: 100%;
   bottom: 0;
   width: 100%;
   z-index: 1;
   display: inline-block;
   position: absolute;

   background: ${props =>
      props.showDescriptionContent
         ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 50%,rgba(0, 0, 0, 1) 100%)'
         : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 50%,rgba(0, 0, 0, 0.85) 100%)'};
`
const MobileOverlayTopGradient = styled.div`
   height: 120px;
   top: 0;
   width: 100%;
   z-index: 1;
   display: inline-block;
   position: absolute;

   background: ${props =>
      props.showDescriptionContent
         ? 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.75) 60%, rgba(255,255,255,0) 100%)'
         : ''};
`
const BreadCrumbsContainerMobile = styled.div`
   .breadcrumb li a {
      color: ${props =>
         props?.hasBackgroundImage
            ? props.showDescriptionContent
               ? 'black'
               : 'white'
            : 'black'} !important; /* Inherit the default styling */
   }

   .breadcrumb li {
      color: ${props =>
         props?.hasBackgroundImage
            ? props.showDescriptionContent
               ? 'var(--color-black)'
               : 'white'
            : 'var(--color-vb-blue)'} !important; /* Revert to default styles */
   }

   ${theme.below.xl} {
      padding: ${props =>
         props.showDescriptionContent
            ? '2rem 0rem 1rem 4rem'
            : '2rem 0rem 0rem 4rem'};
   }

   ${theme.below.md} {
      padding: ${props =>
         props.showDescriptionContent || !props?.hasBackgroundImage
            ? '3rem 0rem 0.5rem 1.5rem'
            : '7rem 0rem 0rem 1.5rem'};
   }
`

const MobileBanner = ({
   bannerContent,
   showDescriptionContent,
   activeCategory,
   parents,
   imageUrl,
   name
}) => {
   const hasBackgroundImage = !!imageUrl

   const titleIconRow = (
      <div className="d-flex position-relative justify-content-between align-items-center z-2 px-128 py-8">
         <h1 className="page-hero-title">{name}</h1>
         {/* {icon && (...)} */}
      </div>
   )

   const mobileDescription = (
      <div className="page-hero-mobile-description d-flex flex-column gap-3 position-relative z-2">
         {showDescriptionContent && (
            <Collapsible
               content={bannerContent}
               open={false}
               closedVisibleHeight={80}
               useDarkText={!imageUrl}
            ></Collapsible>
         )}
      </div>
   )

   const backgroundOverlays = (
      <>
         <MobileOverlayBottom showDescriptionContent={showDescriptionContent} />
         <MobileOverlayTopGradient
            showDescriptionContent={showDescriptionContent}
         />
      </>
   )

   return (
      <HeroContainer
         hasBackgroundImage={hasBackgroundImage}
         className="d-xl-none"
         showDescriptionContent={showDescriptionContent}
      >
         <div className="row p-0 m-0">
            <div className="page-hero col-12 col-xl-6 p-0">
               <div className="page-hero-image">
                  <BreadCrumbsContainerMobile
                     hasBackgroundImage={hasBackgroundImage}
                     showDescriptionContent={showDescriptionContent}
                  >
                     <Breadcrumbs
                        hideLast
                        parents={parents}
                        title={
                           activeCategory?.breadcrumbText ||
                           activeCategory?.name
                        }
                        className="breadcrumb position-relative z-2 m-0"
                     />
                  </BreadCrumbsContainerMobile>
                  {titleIconRow}
                  {mobileDescription}
                  {imageUrl && (
                     <>
                        <img
                           className="img-background img-fluid"
                           src={imageUrl}
                           alt={name}
                        />

                        {backgroundOverlays}
                     </>
                  )}
               </div>
            </div>
         </div>
      </HeroContainer>
   )
}

export default MobileBanner
